jQuery(document).ready(function() {
    console.log("Pradalflex theme");
});



// WEBPACK FOOTER //
// ./js/theme.js